import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { HomePage } from '../home/home'; 

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'page-howto',
  templateUrl: 'howto.html'
})
export class HowToPage {

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(true, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
  }

  goToMainMenu(){
    this.navCtrl.setRoot(HomePage, {});
  }
}



// WEBPACK FOOTER //
// ./src/pages/howto/howto.ts